import { sha256 } from '../port/k4-dispatch/support-b2';

/** Stable browser identity for a uniquely addressed pool (also computable by old saves). */
export function chargeRowIdentity(holder: string, itemId: string): string {
    return rowIdentity(`janus:charges:${holder.toUpperCase()}:${itemId.toUpperCase()}`);
}
export function operationRowIdentity(operationId: string, key: string): string {
    return rowIdentity(`janus:row:${operationId.toUpperCase()}:${key.toUpperCase()}`);
}
function rowIdentity(key: string): string {
    const hash = sha256(key);
    return `${hash.slice(0, 8)}-${hash.slice(8, 12)}-4${hash.slice(13, 16)}-8${hash.slice(17, 20)}-${hash.slice(20, 32)}`.toUpperCase();
}
